module.exports = __webpack_public_path__ + "11320c52646d2e25c96dc1b2cd73cb36.svg";